<template lang="html">
  <transition name="modal-fade">
    <div class="modal-background">

      <div id="new-group-popup" class="container white-box text-center col-lg-4 col-md-4 col-sm-6 col-11" role="dialog">

        <header>
          <h4>Navngiv samlingen</h4>
        </header>

        <section class="row">
        	<input id="new-group-name-input" class="col-6" placeholder="Samlingens navn" aria-label="Samlingens navn" v-model="groupName"/>
        </section>

        <footer>
          <button class="grey btn col-5" @click="$emit('close');">Annuller</button>
        	<button class="blue btn col-5" @click="confirmNewGroup">Bekræft</button>
        </footer>

      </div>

    </div>
  </transition>
</template>

<script>
export default {
  data() {
    return {
      groupName: '',
    }
  },
  props: {
    renameValue: {
      default: false,
    }
  },
  mounted() {
    if(this.renameValue != false) {
      this.groupName = this.renameValue;
    }
    this.$HelperFunctions.setScreenReaderFocus('new-group-name-input');
  },
  methods: {
    confirmNewGroup() {
      if(this.renameValue != false) {
        this.$emit('groupRenamed', this.groupName);
      }
      else {
        this.$emit('createNewGroup', this.groupName);
      }
    }
  }
}
</script>

<style lang="css" scoped>
  #new-group-popup {
    padding: 10px;
  }

  #new-group-name-input {
  	display: block;
  	margin-top: 2px;
  	margin-bottom: 10px;
  	margin-left: auto;
  	margin-right: auto;
  }

  .btn:first-child {
    margin-right: 10px;
  }
</style>
